import React from 'react';
import PropTypes from 'prop-types';
import { Review } from './Review';

export const Reviews = ({ dealerName, reviews }) => {
	return (
		<div className="rdc-reviews-list mt-3">
			<ul className="list-unstyled">
				{reviews.length > 0 &&
					reviews.map((reviewData) => {
						return (
							<Review
								key={reviewData.reviewId}
								reviewData={reviewData}
								dealerName={dealerName}
							/>
						);
					})}
			</ul>
		</div>
	);
};

Reviews.propTypes = {
	dealerName: PropTypes.string.isRequired,
	reviews: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
